import { useEffect, useState } from 'react'
import Dropzone from 'react-dropzone'
import { Button, Grid, Modal, Paper, IconButton, Tooltip, Typography } from '@material-ui/core'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import isEmpty from 'lodash/isEmpty'

import uploadChange from '../../../../../images/icons/uploadChange.svg'
import uploadSave from '../../../../../images/icons/uploadSave.svg'
import pdfImage from '../../../../../images/icons/pdfImage.png'
import downloadICon from '../../../../../images/icons/download.svg'
import IconError from '../../../../../images/error.svg'
import { postToApi } from 'actions'
import { applicationsStyles } from '../../styles'
import { useStateValue } from 'context/store'
import { openSnackBarAction } from 'context/reducers/openSnackbarReducer'
import { closeSpinnerAction, openSpinnerAction } from 'context/reducers/openSpinnerReducer'
import { VALUES } from 'utils/constants'
import { ConfirmationMessage, UploadManualMessage, ICON_SIZE, ACCEPTED_FORMATS } from './UploadManual.utils'

const UploadManual = ({ loadPdf, setLoadPdf, applications, setTextError, setShowError, actionSubmit }) => {
   const classes = applicationsStyles()
   const [_, dispatch] = useStateValue()
   const [filePdfDownload, setFilePdfDow] = useState(null)
   const [temporalFile, setTemporalFile] = useState(null)
   const [confirmationMessage, setConfirmationMessage] = useState(false)
   const [iconConfirm, setIconConfirm] = useState(false)
   const [iconStateChange, setIconStateChange] = useState(true)
   const [pdfDeleteStatus, setPdfDeleteStatus] = useState(false)

   const appManualCode = loadPdf?.manual?.code || ''
   const appCode = loadPdf?.code || ''

   const confirReplacementFile = () => {
      setConfirmationMessage(false)
      setLoadPdf({ ...loadPdf, manualActive: false })
   }

   const fetchFilePdf = async () => {
      const payload = {
         applicationCode: appManualCode
      }
      const url = `${process.env.REACT_APP_APPLICATIONS_API}/applications/generated/url/download/manual`
      const dataFile = await postToApi(url, payload)
      setFilePdfDow(dataFile?.url)
   }

   const handleFileAdd = (acceptedFiles, fileRejections) => {
      if (fileRejections.length === 0) {
         setTemporalFile(acceptedFiles)
         setConfirmationMessage(true)
         setIconStateChange(false)
      } else {
         setShowError(true)
         if (fileRejections[0].errors[0].code == 'file-too-large') {
            const textoError = 'El archivo de imagen sobrepasa el peso permitido'
            setTextError(textoError)
         } else {
            const textoError = 'La extensión no es válida'
            setTextError(textoError)
         }
      }
   }

   // Estado de subida:
   const statusUploadFile = async (codeFile, dataManual) => {
      const tokenApp = localStorage.getItem('token_app')
      const URL_STATUS_UPLOAD = `${process.env.REACT_APP_AUTHORIZATION_API}/user/chenge/status`
      const dataSend = {
         table: 'APPLICATION_USER_MANUAL',
         code: codeFile
      }
      const requestOptions = {
         method: 'PUT',
         headers: {
            Authorization: `Bearer ${tokenApp}`,
            'Content-type': 'application/json'
         },
         body: JSON.stringify(dataSend)
      }
      fetch(URL_STATUS_UPLOAD, requestOptions)
         .then(res => {
            actionSubmit(VALUES.FORM_BEHAVIOR.SEARCH)
            setIconStateChange(false)
            setConfirmationMessage(false)
            dispatch(closeSpinnerAction())
            if (res?.status === 200) {
               // const newRowData = { ...dataManual, manualActive: true }
               // setLoadPdf(newRowData)
               dispatch(openSnackBarAction(`Archivo cargado exitosamente`, 'info'))
            }
         })
         .catch(err => {
            dispatch(closeSpinnerAction())
            dispatch(openSnackBarAction(`Ocurrio un error al intentar subir el archivo ${err}`, 'error'))
         })
   }
   // Segunda llamada para subir el archivo
   const uploadFilePdf = (url, metadata, codeFile, dataManual) => {
      const requestOptions = {
         method: 'PUT',
         headers: {
            'Content-Type': temporalFile[0]?.type,
            ...metadata
         },
         body: temporalFile[0]
      }
      fetch(url, requestOptions)
         .then(res => {
            if (res?.status === 200) {
               statusUploadFile(codeFile, dataManual)
            }
            setIconConfirm(true)
         })
         .catch(err => {
            dispatch(closeSpinnerAction())
            dispatch(openSnackBarAction(`Ocurrio un error al intentar subir el archivo ${err}`, 'error'))
         })
   }

   // Primera llamada para crear la URL firmada
   const pdfFileUrlPresigned = async () => {
      const tokenApp = localStorage.getItem('token_app')
      // try {
      dispatch(openSpinnerAction())

      const URL_PRESIGNED_MANUAL = `${process.env.REACT_APP_APPLICATIONS_API}/applications/generated/url/manual`
      const dataSend = {
         folder: 'application_manual/',
         fileName: temporalFile[0]?.name,
         duration: 120,
         metadata: {},
         applicationCode: appCode
      }
      const requestOptions = {
         method: 'POST',
         headers: {
            Authorization: `Bearer ${tokenApp}`,
            'Content-type': 'application/json'
         },
         body: JSON.stringify(dataSend)
      }
      fetch(URL_PRESIGNED_MANUAL, requestOptions)
         .then(response => response.json())
         .then(data => {
            const newDataApp = applications?.data.map(app => {
               if (app.code === data?.metadata?.['x-goog-meta-session-code']) {
                  app.manual = data
               }
            })
            console.log('🚀 ~ file: table.js:308 ~ newDataApp ~ newDataApp', newDataApp)
            uploadFilePdf(data?.link, data?.metadata, data?.code, data)
         })
         .catch(err => {
            dispatch(closeSpinnerAction())
            dispatch(openSnackBarAction(`Ocurrio un error al intentar subir el archivo ${err}`, 'error'))
         })
   }

   const cancelFileUpload = () => {
      setConfirmationMessage(false)
      setIconStateChange(true)
   }

   const deletePdf = () => {
      setPdfDeleteStatus(true)
   }

   const closeModal = () => {
      setLoadPdf()
      setFilePdfDow(null)
      setConfirmationMessage(false)
      setIconStateChange(true)
      setIconConfirm(false)
      setTemporalFile(null)
      setPdfDeleteStatus(false)
   }

   useEffect(() => {
      if (!isEmpty(loadPdf)) {
         if (!loadPdf?.manual) {
            return
         }
         fetchFilePdf()
      }
   }, [loadPdf])

   return (
      <Modal open={!isEmpty(loadPdf)} disableEscapeKeyDown={false}>
         <div className={classes.modalContainer}>
            <Paper elevation={6} className={classes.modalContent}>
               <div className={classes.dropZoneAreaModal}>
                  <div className={classes.topBoxModal}>
                     <div className={classes.topBoxContainer}>
                        <Typography style={{ color: '#3264DC', fontWeight: '700' }}>Subir Manual</Typography>
                        <Tooltip title="Cerrar">
                           <IconButton aria-label="Cerrar" onClick={closeModal}>
                              <HighlightOffIcon className={classes.closeIcon} />
                           </IconButton>
                        </Tooltip>
                     </div>
                  </div>
                  {!loadPdf?.manualActive && (
                     <>
                        <Dropzone
                           onDrop={(acceptedFiles, fileRejections) => handleFileAdd(acceptedFiles, fileRejections)}
                           maxFiles={1}
                           accept={ACCEPTED_FORMATS}
                           maxSize={ICON_SIZE}
                        >
                           {({ getRootProps, getInputProps }) => (
                              <div {...getRootProps()}>
                                 <input {...getInputProps()} />

                                 <IconButton aria-label="upload-video" className={classes.uploadIconModal}>
                                    {iconStateChange && <CloudUploadIcon style={{ fontSize: 60 }} />}

                                    {confirmationMessage && (
                                       <div>
                                          <img src={uploadChange} alt="" />
                                       </div>
                                    )}
                                    {iconConfirm && (
                                       <div>
                                          <img src={uploadSave} alt="" />
                                       </div>
                                    )}
                                 </IconButton>
                              </div>
                           )}
                        </Dropzone>
                        {confirmationMessage ? (
                           <ConfirmationMessage
                              cancelFileUpload={cancelFileUpload}
                              pdfFileUrlPresigned={pdfFileUrlPresigned}
                              temporalFile={temporalFile}
                           />
                        ) : (
                           <UploadManualMessage
                              classes={classes}
                              iconConfirm={iconConfirm}
                              onAction={closeModal}
                              handleFileAdd={handleFileAdd}
                           />
                        )}
                     </>
                  )}
                  {loadPdf?.manualActive == true && (
                     <>
                        {pdfDeleteStatus == false && (
                           <div className={classes.containerMainPdf}>
                              <Paper elevation={4}>
                                 <div className={classes.containerPdf}>
                                    <img src={pdfImage} alt="" />
                                    <div className={classes.containerIconPdf}>
                                       <a href={filePdfDownload} target="_blank" download rel="noreferrer">
                                          <img className={classes.iconPdf} src={downloadICon} alt="" />
                                       </a>

                                       <p onClick={deletePdf}>
                                          {/* <img className={classes.iconPdf} src={deleteIcon} alt="" /> */}
                                          <CloudUploadIcon
                                             color={'#888da7'}
                                             style={{
                                                cursor: 'pointer',
                                                color: '#888da7'
                                             }}
                                          />
                                       </p>
                                    </div>
                                 </div>
                                 <div>
                                    <p className={classes.pdfName}>
                                       {loadPdf?.manual?.originalName &&
                                          loadPdf?.manual?.originalName?.slice(0, 20) + ' ...'}
                                    </p>
                                    <p className={classes.pdfDate}>
                                       {loadPdf?.manual?.createdDate ?? new Date().toLocaleDateString()}
                                    </p>
                                 </div>
                              </Paper>
                           </div>
                        )}{' '}
                        {pdfDeleteStatus && (
                           <Grid
                              container
                              direction="column"
                              style={{
                                 justifyContent: 'center',
                                 alignItems: 'center',
                                 marginTop: 10
                              }}
                           >
                              <div>
                                 <img src={IconError} alt="" />
                              </div>
                              <Typography style={{ width: '400px' }} variant="subtitle1">
                                 ¿Estas seguro que deseas reemplazar este manual?
                              </Typography>
                              <Grid
                                 item
                                 container
                                 spacing={10}
                                 style={{
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginTop: 10
                                 }}
                              >
                                 <Button
                                    variant="outlined"
                                    color="primary"
                                    style={{
                                       marginRight: 30,
                                       width: '158px'
                                    }}
                                    onClick={() => setPdfDeleteStatus(false)}
                                 >
                                    Cancelar
                                 </Button>
                                 <Button
                                    variant="contained"
                                    style={{ width: '158px' }}
                                    color="primary"
                                    onClick={confirReplacementFile}
                                 >
                                    Aceptar
                                 </Button>
                              </Grid>
                           </Grid>
                        )}
                     </>
                  )}
               </div>
            </Paper>
         </div>
      </Modal>
   )
}

export default UploadManual
